

var chatbetQueryParams = getParameterByName('chatbet') || undefined
// var url = "https://12d1ebc5.ngrok.io" 
// var url = "https://staging-chatbet.herokuapp.com"
var url = "https://chatbet.herokuapp.com"

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

window.location.href = "https://chatbet.io/store?chatbet=" + (chatbetQueryParams || getCookie('chatbet'))

function deleteCookie(name) {
  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

if(!getCookie('chatbet') || getCookie('chatbet') == 'null' || getCookie('chatbet') == 'undefined') {
  if(!chatbetQueryParams || chatbetQueryParams == '' || chatbetQueryParams === undefined) {
    window.location.href = "https://m.me/ChatbetGame";
  } else {
    setCookie('chatbet', chatbetQueryParams, 1);
  }
}

$.ajax({
    type: 'GET',
    data: {
      chatbet: chatbetQueryParams || getCookie('chatbet')
    },
    url: url + "/api/users/coins"
  })
  .done(function(data){
	data = data ? data : 0;
	$('#coins').text(data);
  })
  .fail(function(err) {
  	deleteCookie('chatbet');
	window.location.href = "https://m.me/ChatbetGame";
  })
  ;

$('.a-chatbet').click(function(e) {
  if(e.target.text === 'Leaderboard') {
    e.preventDefault();
    window.location.href = "https://chatbet.io/leaderboard?chatbet=" + getCookie('chatbet') || chatbetQueryParams;
  }
})

$('.t-chatbet-game').click(function(e) {
    e.preventDefault();
    window.location.href = "https://chatbet.io/leaderboard?chatbet=" + getCookie('chatbet') || chatbetQueryParams;
})

$('.t-chatbet-profile').click(function(e) {
    e.preventDefault();
    window.location.href = "https://chatbet.io/profile?chatbet=" + getCookie('chatbet') || chatbetQueryParams;
})

$('.t-chatbet-friends').click(function(e) {
    e.preventDefault();
    window.location.href = "https://chatbet.io/friends?chatbet=" + getCookie('chatbet') || chatbetQueryParams;
})



function getParameterByName(name, url) {
  if (!url) {
    url = window.location.href;
  }
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
     results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

var productToBuy = "";

function getProduct(productTitle) {
  productToBuy = productTitle;
  $.ajax({
    type: 'POST',
    data: {
      productTitle: productTitle,
      chatbet: chatbetQueryParams || getCookie('chatbet')
    },
    url: url + "/api/shopify/wanttobuy"
  })
  .done(function(data){
	modal.style.display = "block";
    $('#modal-text').text(data.text);
    $('#modal-title').text(data.title);
    $('.modal-button').text(data.cta);
    modalButtonConfirm.style.display = 'block';
    modalButtonInvite.style.display = 'none';
  })
  .fail(function(err) {
    modal.style.display = "block";
    $('#modal-text').text(err.responseJSON.text);
    $('#modal-title').text(err.responseJSON.title);
    $('.modal-button').text(err.responseJSON.cta);
    if(err.responseJSON.cta) {
	  modalButtonInvite.style.display = 'block';
    }
    modalButtonConfirm.style.display = 'none';
  })
  ;
}

function getUrl() {
  $.ajax({
    type: 'POST',
    data: {
      productTitle: productToBuy,
      chatbet: chatbetQueryParams || getCookie('chatbet')
    },
    url: url + "/api/shopify/buy"
  })
  .done(function(data){
    console.log("done", data.url);
	window.location.href = data.url;
  })
  .fail(function(err) {
    modal.style.display = "block";
    $('#modal-text').text(err.responseJSON.text);
    $('#modal-title').text(err.responseJSON.title);
    $('.modal-button').text(err.responseJSON.cta);
    modalButtonInvite.style.display = 'block';
  })
  ;
}

function goToLeaderboard() {
  window.location.href = "https://chatbet.io/leaderboard?chatbet=" + getCookie('chatbet') || chatbetQueryParams;
}

function goToLearnMore() {
  window.location.href = "https://chatbet.io/leaderboard?chatbet=" + (getCookie('chatbet') || chatbetQueryParams) + "&freestuff=true";
}

function inviteFriendsClick() {
  window.location.href = "https://chatbet.io/leaderboard?chatbet=" + (getCookie('chatbet') || chatbetQueryParams) + "&freestuff=true";
}

function confirmBuyClick(e) {
  getUrl()
}

function commafy( num ) {
    var str = num.toString().split('.');
    if (str[0].length >= 5) {
        str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
    }
    if (str[1] && str[1].length >= 5) {
        str[1] = str[1].replace(/(\d{3})/g, '$1 ');
    }
    return str.join('.');
}

$('.money-chatbet').each(function(index, item){
    $(item).text(commafy(parseInt($(item).text())))
});


// Get the modal
var modal = document.getElementById('myModal');

var modalButtonInvite = document.getElementById('modal-btn-invite');
var modalButtonConfirm = document.getElementById('modal-btn-confirm');
var modalButtonClose = document.getElementById('close');

// Get the button that opens the modal
var btn = document.getElementById("myBtn");

// When the user clicks on <span> (x), close the modal
modalButtonClose.onclick = function() {
    modal.style.display = "none";
}

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
    if (event.target == modal) {
        modal.style.display = "none";
    }
}


var tabbar = document.getElementById('chatbet-tabbar');
setTimeout(function(){ tabbar.style.position = "fixed"; }, 200)
